module.exports = __webpack_public_path__ + "static/media/suggestedToFriends_50_75.4dda6754.png";